





















































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import { solicitudes_eventos_audit } from "@/shared/dtos/solicitudes_eventos_audit";
import solicitudesEventosAuditModule from "@/store/modules/solicitudes_eventos_audit-module";

@Component({ name: "SolicitudesEventosAuditManager" })
export default class SolicitudesEventosAuditManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public dialogOpen: boolean = false;
  public isEditMode: boolean = false;
  public searchText: string = "";
  public tiposActor: string[] = ["paciente", "admin", "sistema"];
  public form: solicitudes_eventos_audit = new solicitudes_eventos_audit();
  public headers: any[] = [
    { text: "ID", value: "id", width: "90px" },
    { text: "Solicitud", value: "id_solicitud", width: "120px" },
    { text: "Tipo", value: "tipo_evento", width: "140px" },
    { text: "Actor", value: "actor_tipo", width: "120px" },
    { text: "Descripcion", value: "descripcion" },
    { text: "Fecha", value: "created_at", width: "180px" },
    { text: "Acciones", value: "actions", sortable: false, width: "110px" }
  ];

  public mounted() { this.refresh(); }
  public get rows(): solicitudes_eventos_audit[] { return solicitudesEventosAuditModule.rows; }
  public get filteredRows(): solicitudes_eventos_audit[] {
    const s = (this.searchText || "").toLowerCase().trim();
    if (!s) return this.rows;
    return this.rows.filter(x => (String(x.id_solicitud) + " " + (x.tipo_evento || "") + " " + (x.descripcion || "")).toLowerCase().indexOf(s) !== -1);
  }
  public async refresh() { this.loading = true; try { await solicitudesEventosAuditModule.getRows(); } finally { this.loading = false; } }
  public openCreate() { this.isEditMode = false; this.form = new solicitudes_eventos_audit(); this.form.actor_tipo = "sistema"; this.dialogOpen = true; }
  public openEdit(item: solicitudes_eventos_audit) { this.isEditMode = true; this.form = new solicitudes_eventos_audit(item); this.dialogOpen = true; }
  public async save() {
    if (this.form.id_solicitud <= 0 || !this.form.tipo_evento) {
      MessageService.alert("Validacion", "ID solicitud y tipo evento son obligatorios", MessageService.TypeWarning);
      return;
    }
    this.saving = true;
    try {
      this.form.tipo_evento = (this.form.tipo_evento || "").trim();
      this.form.descripcion = (this.form.descripcion || "").trim();
      this.form.datos_json = (this.form.datos_json || "").trim();
      this.form.ip = (this.form.ip || "").trim();
      this.form.user_agent = (this.form.user_agent || "").trim();
      if (this.isEditMode) await solicitudesEventosAuditModule.modificar(this.form); else await solicitudesEventosAuditModule.guardar(this.form);
      this.dialogOpen = false;
      await this.refresh();
    } finally { this.saving = false; }
  }
  public remove(item: solicitudes_eventos_audit) {
    MessageService.confirm("Quieres eliminar este evento?", "Confirmacion", async (res: boolean) => {
      if (!res) return;
      await solicitudesEventosAuditModule.eliminar(item);
      await this.refresh();
    });
  }
}
